<template>
  <div class="admin-content w1000">
    <div class="admin-content-header">
      <router-link to="/admin/article/add">
        <el-button type="primary" icon="el-icon-edit">写文章</el-button>
      </router-link>
      <el-tabs v-model="activeName" class="admin-tabs" @tab-click="changeTabs">
        <el-tab-pane label="未发布" name="3"></el-tab-pane>
        <el-tab-pane label="已发布" name="0"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="article-list" data-grid>
      <div class="article-item" v-for="item in list" :key="item.id" data-packed>
        <div class="publish">
          <span class="time">{{item.createTime}}</span>
          <span class="user">{{item.author}}</span>
        </div>
        <div class="tips" v-if="!item.imageUrl || !item.title">文章内容不完整</div>
        <div class="content">
          <div class="pic" v-if="item.imageUrl"><img :data-src="item.imageUrl | imageUrl" :src="item.imageUrl | imageUrl('?imageView2/1/w/276/h/160')" /></div>
          <h4 class="title">{{item.title}}</h4>
          <p class="desc">{{item.subject}}</p>
          <template v-if="item.imageUrl && item.title">
            <a :href="`//img.zai-art.com/${item.siteurl}?t=${+new Date()}`" target="_blank" v-if="item.flagDelete === '已发布'">
              <div class="mask">
                <span>查看文章</span>
              </div>
            </a>
            <router-link :to="`/admin/article/edit/${item.id}`" v-else-if="item.flagDelete !== '已删除'">
              <div class="mask">
                <span>编辑文章</span>
              </div>
            </router-link>
          </template>
        </div>
        <div class="tools">
          <p class="item-status" v-if="item.flagDelete === '已删除'">已删除</p>
          <ul class="col-1" v-else-if="item.flagDelete === '已发布'">
            <li>
              <el-tooltip content="删除" placement="top">
                <el-popover placement="bottom" v-model="item.removeVisible">
                  <div class="admin-popover">
                    <p>确定删除此文章吗？</p>
                    <el-button size="mini" plain @click="item.removeVisible = false">取消</el-button>
                    <el-button size="mini" type="primary" @click="onRemove(item)">确定</el-button>
                  </div>
                  <div slot="reference">
                    <i class="del-icon">删除</i>
                  </div>
                </el-popover>
              </el-tooltip>
            </li>
          </ul>
          <ul class="col-2" v-else>
            <li v-if="item.imageUrl && item.title">
              <el-tooltip content="发布" placement="top">
                <el-popover placement="bottom" v-model="item.publishVisible">
                  <div class="admin-popover">
                    <p>确定发布此文章吗？</p>
                    <el-button size="mini" plain @click="item.removeVisible = false">取消</el-button>
                    <el-button size="mini" type="primary" @click="onPublish(item)">确定</el-button>
                  </div>
                  <div slot="reference">
                    <i class="publish-icon">发布</i>
                  </div>
                </el-popover>
              </el-tooltip>
            </li>
            <li v-else>
              <el-tooltip content="修改" placement="top">
                <div>
                  <router-link :to="`/admin/article/edit/${item.id}`">
                    <i class="edit-icon">修改</i>
                  </router-link>
                </div>
              </el-tooltip>
            </li>
            <li>
              <el-tooltip content="删除" placement="top">
                <el-popover placement="bottom" v-model="item.removeVisible">
                  <div class="admin-popover">
                    <p>确定删除此文章吗？</p>
                    <el-button size="mini" plain @click="item.removeVisible = false">取消</el-button>
                    <el-button size="mini" type="primary" @click="onRemove(item)">确定</el-button>
                  </div>
                  <div slot="reference">
                    <i class="del-icon">删除</i>
                  </div>
                </el-popover>
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="admin-pager" v-if="pageTotal">
      <el-pagination @current-change="onCurrentChange" :current-page.sync="listParam.page.index" layout="prev, pager, next, jumper" :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Bricks from 'bricks.js'
import { getArticleList, updateArticleStatus } from '@/api/admin'

let instance = null
export default {
  data: () => ({
    removeVisible: false,
    publishVisible: false,
    activeName: '3',
    list: [],
    listParam: {
      title: null,
      flagDelete: 3,
      page: { index: 1, size: 10 }
    },
    pageTotal: 0
  }),
  methods: {
    init() {
      this.getList()
    },
    // 获取列表数据
    getList() {
      return getArticleList(this.listParam).then(response => {
        this.list = response.data.list || []
        this.pageTotal = response.data.totle_count
      })
    },
    // 切换tab
    changeTabs(tab) {
      this.listParam.flagDelete = this.activeName
      this.listParam.page.index = 1
      this.listParam.page.size = 10
      this.getList()
    },
    // 更新数据状态
    updateStatus(id, flag) {
      return updateArticleStatus({ id, flag }).then(response => {
        this.getList()
      })
    },
    // 删除
    onRemove(item) {
      item.removeVisible = false
      this.updateStatus(item.id, 1)
    },
    // 发布
    onPublish(item) {
      item.publishVisible = false
      this.updateStatus(item.id, 0)
    },
    onCurrentChange(currentPage) {
      this.getList()
    }
  },
  mounted() {
    this.$nextTick(() => {
      instance = Bricks({
        container: '[data-grid]',
        packed: 'data-packed',
        sizes: [{ columns: 3, gutter: 20 }]
      })
      instance.resize(true).pack()
    })
  },
  updated() {
    this.$nextTick(() => {
      instance && instance.resize(true).pack()
    })
  },
  created() {
    this.init()
  }
}
</script>
<style>
.article-item {
  overflow: hidden;
  width: 302px;
  margin: 0 0 20px;
  border: 1px solid #e7e7eb;
}
.article-item .content {
  position: relative;
  padding: 0 10px 10px;
}
.article-item .content .mask {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  z-index: 1;
  padding: 14px;
  cursor: pointer;
}
.article-item .content .mask:after {
  content: ' ';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.article-item .content .mask span {
  font-size: 16px;
  color: #fff;
  display: inline-block;
  vertical-align: middle;
}
.article-item .content:hover .mask {
  display: block;
}
.article-item .publish {
  margin: 0 10px;
  height: 38px;
  font-size: 12px;
  line-height: 38px;
  color: #333;
  overflow: hidden;
}
.article-item .publish .time {
  float: left;
}
.article-item .publish .user {
  float: right;
}
.article-item .content .pic {
  height: 160px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.article-item .content .pic img {
  min-width: 100%;
  min-height: 100%;
}
.article-item .content .title {
  margin: 8px 0;
  font-size: 16px;
  font-weight: 400;
  color: #333;
}
.article-item .content .desc {
  font-size: 12px;
  line-height: 24px;
  color: #333;
}
.article-item .tools .item-status {
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background-color: #838388;
  border-top: 1px solid #838388;
}
.article-item .tools ul {
  height: 40px;
  border-top: 1px solid #e7e7eb;
  background-color: #fff;
}
.article-item .tools li {
  float: left;
  position: relative;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.article-item .tools li a {
  display: block;
}
.article-item .tools .col-1 li {
  width: 100%;
}
.article-item .tools .col-2 li {
  width: 50%;
}
.article-item .tools li:after {
  position: absolute;
  right: 0;
  top: 10px;
  bottom: 10px;
  content: ' ';
  width: 1px;
  background-color: #e7e7eb;
}
.article-item .tools li:last-child:after {
  display: none;
}
.article-item .tools i {
  vertical-align: middle;
  display: inline-block;
  text-indent: -999em;
  overflow: hidden;
}
.article-item .tools .publish-icon {
  width: 21px;
  height: 22px;
  background: url('../../../assets/img/admin/article_publish_icon.png')
    no-repeat;
  background-size: 100%;
}
.article-item .tools a:hover .publish-icon {
  background-image: url('../../../assets/img/admin/article_publish_hover_icon.png');
}
.article-item .tools .del-icon {
  width: 16px;
  height: 24px;
  background: url('../../../assets/img/admin/article_delete_icon.png') no-repeat;
  background-size: 100%;
}
.article-item .tools a:hover .del-icon {
  background-image: url('../../../assets/img/admin/article_delete_hover_icon.png');
}
.article-item .tools .edit-icon {
  width: 21px;
  height: 21px;
  background: url('../../../assets/img/admin/article_edit_icon.png') no-repeat;
  background-size: 100%;
}
.article-item .tools a:hover .edit-icon {
  background-image: url('../../../assets/img/admin/article_edit_hover_icon.png');
}
.article-item .tools .retract-icon {
  width: 21px;
  height: 21px;
  background: url('../../../assets/img/admin/article_retract_icon.png')
    no-repeat;
  background-size: 100%;
}
.article-item .tools a:hover .retract-icon {
  background-image: url('../../../assets/img/admin/article_retract_hover_icon.png');
}
.article-item .tips {
  color: #ffbe00;
  padding-top: 3px;
  margin: 0 10px;
}
</style>
